import { MutationTree } from 'vuex';
import {ClientAttributesState} from "@/store/cdp/client_attributes/types";

export const mutations: MutationTree<ClientAttributesState> = {
  setClientAttributes: (state, payload) => {
    state.clientAttributes = payload;
  },
  setClientAttributeItem:(state, payload) => {
    state.clientAttributesItem = payload
  }
}
